import { Grid } from 'common/layouts/grid/Grid';
import { Flex } from 'component-library/components/layout/Flex';
import { ResponsiveBody } from 'component-library/components/typography/ResponsiveBody';
import { ResponsiveHeading } from 'component-library/components/typography/ResponsiveHeading';
import { Screen, ShowOn } from 'component-library/components/wrappers/ShowOn';
import React, { FC } from 'react';
import styled from 'styled-components';

import { ValuePropGridSectionProps } from '.';
import { GridSectionWrapper } from './GridSectionWrapper';
import { ValuePropItem } from './ValuePropItem';

const Wrapper = styled(ShowOn)`
  max-width: 1314px;
  padding: 120px 40px 0;
  margin: auto;
`;

const Image = styled.div`
  width: 36%;
`;

const StyledFlex = styled(Flex)`
  gap: 80px;
`;

export const ValuePropGridSectionLarge: FC<ValuePropGridSectionProps> = ({
  heading,
  body,
  valueProps,
  Button,
  image,
}) => (
  <Wrapper screens={[Screen.Lg, Screen.Xl, Screen.Xxl]}>
    <StyledFlex marginBottom={80}>
      <Image>{image}</Image>
      <Flex column>
        <ResponsiveHeading variant={2} marginBottom={24}>
          {heading}
        </ResponsiveHeading>
        <ResponsiveBody variant={1} marginBottom={48}>
          {body}
        </ResponsiveBody>
        <Button />
      </Flex>
    </StyledFlex>
    <GridSectionWrapper padding="88px">
      <Grid cols={3} gap={6}>
        {valueProps.map((valueProp, idx) => (
          <ValuePropItem {...valueProp} key={idx} />
        ))}
      </Grid>
    </GridSectionWrapper>
  </Wrapper>
);
